// 盘库记录
import { axiosPost } from "@/utils/request";

/**
 * 查询盘库记录
 * @param {*} data
 * @returns
 */
export const selectCheckInventoryRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/selectCheckInventoryRecord",
    data: data,
  });
};
/**
 * 新增自定义盘库记录
 * @param {*} data
 * @returns
 */
export const insertCustomCheckInventoryRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/insertCustomCheckInventoryRecord",
    data: data,
  });
};
/**
 * 查询盘库产品
 * @param {*} data
 * @returns
 */
export const selectCheckInventoryProductRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/selectCheckInventoryProductRecord",
    data: data,
  });
};
/**
 * 盘点结束
 * @param {*} data
 * @returns
 */
export const checkEnd = (data) => {
  return axiosPost({
    url: "/checkInventory/checkEnd",
    data: data,
  });
};
/**
 * 盘点录入
 * @param {*} data
 * @returns
 */
export const checkInput = (data) => {
  return axiosPost({
    url: "/checkInventory/checkInput",
    data: data,
  });
};
/**
 * 查询盘库产品检查记录
 * @param {*} data
 * @returns
 */
export const selectCheckInventoryCheckRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/selectCheckInventoryCheckRecord",
    data: data,
  });
};
/**
 * 查询主材盘点异常设备，盘点结束前调用，查询是否有盘点异常的设备
 * @param {*} data
 * @returns
 */
export const selectMainCheckError = (data) => {
  return axiosPost({
    url: "/checkInventory/selectMainCheckError",
    data: data,
  });
};
/**
 * 查询辅材和耗材未录入盘点数量，盘点结束前调用，查询是否有未录入盘点数量的辅材和耗材
 * @param {*} data
 * @returns
 */
export const selectOtherCheckError = (data) => {
  return axiosPost({
    url: "/checkInventory/selectOtherCheckError",
    data: data,
  });
};
/**
 * 盘库出入库
 * @param {*} data
 * @returns
 */
export const selectOutInRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/selectOutInRecord",
    data: data,
  });
};
/**
 * 修改盘点状态
 * @param {*} data
 * @returns
 */
export const updateCheckStatus = (data) => {
  return axiosPost({
    url: "/checkInventory/updateCheckStatus",
    data: data,
  });
};
/**
 * 修改盘库产品记录
 * @param {*} data
 * @returns
 */
export const updateActualTotal = (data) => {
  return axiosPost({
    url: "/checkInventory/updateActualTotal",
    data: data,
  });
};
/**
 * 更新库存数量（只能更新辅材和耗材的库存数量）
 * @param {*} data
 * @returns
 */
export const updateInventoryTotal = (data) => {
  return axiosPost({
    url: "/checkInventory/updateInventoryTotal",
    data: data,
  });
};

/**
 * 查询库存盘点审批记录
 * @param {*} data
 * @returns
 */
export const selectCheckInventoryApprovalRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/selectCheckInventoryApprovalRecord",
    data: data,
  });
};
/**
 * 盘库审批其他（辅材和耗材）处置方式
 * @param {*} data
 * @returns
 */
export const checkInventoryApprovalOtherDisposalMode = (data) => {
  return axiosPost({
    url: "/checkInventory/checkInventoryApprovalOtherDisposalMode",
    data: data,
  });
};
/**
 * 盘库审批主材处置方式-批量
 * @param {*} data
 * @returns
 */
export const checkInventoryApprovalMainDisposalMode = (data) => {
  return axiosPost({
    url: "/checkInventory/checkInventoryApprovalMainDisposalMode",
    data: data,
  });
};
/**
 * 审批完成
 * @param {*} data
 * @returns
 */
export const checkInventoryApprovalEnd = (data) => {
  return axiosPost({
    url: "/checkInventory/checkInventoryApprovalEnd",
    data: data,
  });
};
/**
 * 库存审批 查询接口
 * @param {*} data
 * @returns
 */
export const selectCheckInventoryProductRecordAndRealInventoryTotal = (data) => {
  return axiosPost({
    url: "checkInventory/selectCheckInventoryProductRecordAndRealInventoryTotal",
    data: data,
  });
};
/**
 * 查询主材审批异常设备，审批结束前调用，查询是否有审批异常的设备
 * @param {*} data
 * @returns
 */
export const selectMainApprovalError = (data) => {
  return axiosPost({
    url: "/checkInventory/selectMainApprovalError",
    data: data,
  });
};
/**
 * 查询辅材和耗材审批没有处理方式，审批结束前调用，查询是否有未处理的辅材和耗材
 * @param {*} data
 * @returns
 */
export const selectOtherApprovalError = (data) => {
  return axiosPost({
    url: "/checkInventory/selectOtherApprovalError",
    data: data,
  });
};
/**
 * 查缺处理-单条数据修改
 * @param {*} data
 * @returns
 */
export const updateCheckRecord = (data) => {
  return axiosPost({
    url: "/checkInventory/updateCheckRecord",
    data: data,
  });
};